import React, {Component} from "react";

export class CurrencySelect extends Component {
    static currenciesCodes = ["ARS", "USD", "CLP", "MXN", "PYG", "BRL", "EUR", "UYU", "GBP", "PEN", "COP", "AUD", "ILS", "SEK", "NOK", "DKK", "ISK", "GBP", "CHF", "JPY", "CNY"]
    static AD_ACCOUNT_CURRENCY = "Moneda de cuenta publicitaria";

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    getCurrenciesCodes() {
        let currencies = CurrencySelect.currenciesCodes;
        if(this.props.onlyAdAccountCurrencyMode === true) {
            return currencies.concat([CurrencySelect.AD_ACCOUNT_CURRENCY]);
        }
        return currencies
    }

    handleChange(event) {
        if(this.props.onlyAdAccountCurrencyMode === true && event.target.value !== CurrencySelect.AD_ACCOUNT_CURRENCY) {
            event.preventDefault();
            alert("Para seleccionar un tipo de moneda en especial debe tener habilitado el módulo multi-moneda. Revise el plan contratado.")
            return;
        }

        if(this.props.onChange) {
            this.props.onChange(event);
        }
    }

    renderNullOptionIfNecessary() {
        if(this.props.selected === null) {
            return <option key='empty-option' value=''>-----</option>
        }
    }

    render() {
        let selected = this.props.selected;
        if(this.props.onlyAdAccountCurrencyMode === true) {
            selected = CurrencySelect.AD_ACCOUNT_CURRENCY;
        }

        if(this.props.readOnly===true) {
            return <input value={selected} readOnly={true} className={"form-control"}/>
        }

        const options = this.getCurrenciesCodes();
        return (<select className={"form-control form-select"}
                        value={selected} {...this.props}
                        onChange={this.handleChange}
                        required={this.props.required}
            >
                {this.renderNullOptionIfNecessary()}
                {options.map((option) => (
                    <option value={option}
                            key={option}
                    >{option}</option>
                ))}
            </select>
        )
    }
}
